import React from "react";
import { useRouteData } from "react-static";
import { useI18n } from "../../I18nextProvider";

const Logo = () => {
  const i18n = useI18n();

  const current = useRouteData();
  const { lang, type, id } = current;

  const mcnLogoFr = require("../../assets/images/logo-musee-numerique-blanc.svg");
  const mcnLogoEn = require("../../assets/images/logo-musee-numerique-blanc-en.svg");

  return (
    <div className="comp-logos">
      <p className="rendu-possible">{i18n.t("partenaires.rendu_possible")}</p>
      <a className="entente" rel="noreferrer" href="#">
        <img
          src={require("../../assets/images-ms/logos/entente-dev-culturel.webp")}
          alt={i18n.t("partenaires.ententeculturelle.titre")}
        />
      </a>
      <div className="en-collab" dangerouslySetInnerHTML={{ __html: i18n.t("partenaires.en_collaboration") }} />
      <div
        className="en-collab lineaire"
        dangerouslySetInnerHTML={{ __html: i18n.t("partenaires.en_collaboration_lineaire") }}
      />
      <div className="autres-logos">
        <a target="_blank" className="mrc" rel="noreferrer" href={i18n.t("partenaires.mrc.url")}>
          <img src={require("../../assets/images-ms/logos/mrcmatanie.svg")} alt={i18n.t("partenaires.mrc.titre")} />
        </a>
        <a target="_blank" className="shgm" rel="noreferrer" href={i18n.t("partenaires.shgm.url")}>
          <img src={require("../../assets/images-ms/logos/sh.svg")} alt={i18n.t("partenaires.shgm.titre")} />
        </a>
        <a target="_blank" className="rzs" rel="noreferrer" href={i18n.t("partenaires.rzs.url")}>
          <img src={require("../../assets/images-ms/logos/richardz.svg")} alt={i18n.t("partenaires.rzs.titre")} />
        </a>
        <a target="_blank" className="cube" rel="noreferrer" href={i18n.t("partenaires.cubenoir.url")}>
          <img src={require("../../assets/images-ms/logos/cubenoir.svg")} alt={i18n.t("partenaires.cubenoir.titre")} />
        </a>
        <a target="_blank" className="idhp" rel="noreferrer" href={i18n.t("partenaires.idhp.url")}>
          <img src={require("../../assets/images-ms/logos/idhp.svg")} alt={i18n.t("partenaires.idhp.titre")} />
        </a>
      </div>
    </div>
  );
};

export default Logo;
